export default "__VITE_ASSET__CwuHuG$r__"